<div class="p-3 flex-row flex-wrap">
  <h3 mat-dialog-title class="w-100">{{title}} '{{customer.name}}'</h3>
  <mat-dialog-content class="w-100">
    <span>(customer since: {{customer.added | date:"shortDate"}})</span>
    @if (busyLoadingFeeSchedule) {
      <app-mat-spinner-overlay  [overlay]="true"></app-mat-spinner-overlay>
    }
    <form [formGroup]="feeScheduleForm" class="w-100 mt-3">
      <div class="w-100 flex-row justify-center items-stretch">
        <mat-form-field appearance="outline" class="w-50">
          <mat-select placeholder="Select Fee Type" required formControlName="feeType">
            @for (feeType of availableFeeTypes; track feeType) {
              <mat-option [value]="feeType">
                {{feeType.displayName}}
              </mat-option>
            }
          </mat-select>
          @if (feeScheduleForm.controls.feeType.errors?.required) {
            <mat-error>Selection is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-50">
          <mat-label>Amount</mat-label>
          <input matInput formControlName="amount" autocomplete="off" type="number" min="0" >
          @if (feeScheduleForm.controls.amount.errors?.min) {
            <mat-error>Value cannot be negative</mat-error>
          }
          <mat-hint>Enter amount in $</mat-hint>
        </mat-form-field>
      </div>
      <div formArrayName="discountSchedule" class="w-100 flex-col justify-start items-stretch">
        @for (discountItem of discountScheduleControls; track $index; let i = $index; let isLast = $last) {
          <div class="w-100 flex-col justify-start items-stretch pb-2">
            <mat-card>
              <mat-card-content>
                <div [formGroupName]="i" class="w-100 flex-row flex-wrap justify-start items-stretch">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-47">
                    <mat-label>Discount Percent</mat-label>
                    <input matInput formControlName="discountPercent" autocomplete="off" type="number" required>
                    @if (discountItem.get('discountPercent')?.errors?.required) {
                      <mat-error>Input is required</mat-error>
                    }
                    @if (discountItem.get('discountPercent')?.errors?.min) {
                      <mat-error>Minimum value is 0</mat-error>
                    }
                    @if (discountItem.get('discountPercent')?.errors?.max) {
                      <mat-error>Maximum value is 100</mat-error>
                    }
                    <mat-hint>Discounted amount: ${{discountedAmount($safeNavigationMigration(discountItem.get('discountPercent')?.value))}}</mat-hint>
                  </mat-form-field>
                  <mat-form-field  appearance="outline" subscriptSizing="dynamic" class="w-47">
                    <mat-label>Until</mat-label>
                    <input matInput formControlName="until" autocomplete="off" type="date" required>
                    @if (discountItem.get('until')?.errors?.required) {
                      <mat-error>Input is required</mat-error>
                    }
                    @if (discountItem.get('until')?.errors?.badDateSequence) {
                      <mat-error>Bad date sequence</mat-error>
                    }
                    <mat-hint></mat-hint>
                  </mat-form-field>
                  <button class="w-6 pt-2 hide-button" mat-icon-button color="primary" (click)="deleteDiscountScheduleItem(i)" matTooltip="Delete Discount">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        }
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="mt-3 p-2 w-100">
    <div class="w-100 flex-row space-between items-center">
      <div class="w-50 flex-row justify-start items-center">
        <a mat-button color="primary" class="dialog-btn mr-5" (click)="addDiscountScheduleItem()"><span class="text-bold">Add Discount Item</span></a>
      </div>
      <div class="w-50 flex-row justify-end items-center">
        <a mat-button color="primary" class="dialog-btn mr-5" (click)="onCancelClick()"><span class="text-bold">{{cancelButtonText}}</span></a>
        <a mat-button color="primary" class="dialog-btn" [disabled]='!canSave' (click)="onSaveClick()"><span class="text-bold">{{saveButtonText}}</span></a>
      </div>
    </div>
  </mat-dialog-actions>
</div>
